import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const SectionWrapper = styled.div`
  background-color: ${({ backgroundColor }) =>
    backgroundColor || 'var(--color-accent-secondary-weakest)'};
  border-radius: var(--radius-m);
  padding: 16px;
  position: relative;

  ${DEVICE.mobile.max} {
    border-radius: var(--radius-m);
    padding: 16px;
  }
`;

const EmptySectionWrapper = styled.div`
  align-items: center;
  background: var(--color-bg-weak);
  border: 1px solid var(--color-accent-secondary-weaker);
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
`;

export { EmptySectionWrapper, SectionWrapper };
